import { FC } from 'react';
import { SubmissionErrorBoundary } from '../../../components/errors/SubmissionErrorBoundary';
import { Modal } from '../../../components/shared/modal/Modal';
import { EmployeeWorkTimeRecord } from '../../../services/gql/graphql.generated';
import strings from '../shifts.translations';
import { EditShiftForm } from './EditShiftForm';

interface EditShiftModalProps {
  shift: EmployeeWorkTimeRecord;
  open: boolean;
  onClose: () => void;
  suggestedOutTime?: Date;
  isMe?: boolean;
}

export const EditShiftModal: FC<EditShiftModalProps> = ({ shift, open, suggestedOutTime, onClose, isMe }) => {
  return (
    <Modal open={open} onClose={onClose} header={strings.detailView.editShift}>
        <SubmissionErrorBoundary>
          <EditShiftForm onComplete={onClose} shift={shift} suggestedOutTime={suggestedOutTime} isMe={isMe} />
        </SubmissionErrorBoundary>
    </Modal>
  );
};
